import {
    type NovelItem,
    NovelItem_Status,
    SearchNovelsRequest,
    type SearchNovelsRequest_ChampionFilter,
    SearchNovelsRequest_FilterOperator,
    type SearchNovelsRequest_SortType,
} from '@app/_proto/Protos/novels';
import { NovelsClient } from '@app/_proto/Protos/novels.client';
import { useGrpcApiWithQuery } from '@app/libs/api';
import { useGrpcRequest } from '@app/libs/grpc';

type UseSearchNovelsParam = {
    genres: string[];
    sortType?: SearchNovelsRequest_SortType;
    status?: NovelItem_Status;
    count?: number;
    enabled?: boolean;
    championFilter?: SearchNovelsRequest_ChampionFilter;
};

type UseSearchNovelsReturn = {
    data: NovelItem[] | undefined;
    isSuccess: boolean;
};

export default function useSearchNovels({
    genres,
    sortType,
    status = NovelItem_Status.Finished,
    count,
    enabled,
    championFilter,
}: UseSearchNovelsParam): UseSearchNovelsReturn {
    const novelsRequest = useGrpcRequest(SearchNovelsRequest, {
        genresFilter: {
            genres,
            operator: SearchNovelsRequest_FilterOperator.Or,
        },
        sortType: sortType,
        status,
        count,
        championFilter,
    });

    const { data, isSuccess } = useGrpcApiWithQuery(
        NovelsClient,
        c => c.searchNovels,
        novelsRequest,
        ['novels', genres.join(), sortType, status, count, championFilter],
        {
            enabled,
            cacheTime: 1000 * 60 * 60 * 24, // 24 hours cache
            staleTime: 1000 * 60 * 60 * 24, // Data stales in 24 hours
        }
    );

    return {
        data: data?.items,
        isSuccess,
    };
}
